import React from "react";
import Markdown from "react-markdown";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

function EventCalendar({ data }) {
    return (
        <div key={data.documentId}
             className="row container-fluid background-full-width event-calendar light-gray-background  screen-width">
            <div className={"col-sm-3 event-calendar-spacer"}></div>
            <div className={"container container-fluid calendar-list-div col-sm-6"} >
                {data.calendarEventItems.map((item, index) => (
                    <div key={item.id} className="event-calendar-listing">
                        <div className={"calendar-headline"}>
                            <div className="calendar-event-text">
                                <strong>{item.title}</strong><br/>
                                {new Date(item.startDateTime).toLocaleString()}
                                {" to"}
                                <br/>
                                {new Date(item.endDateTime).toLocaleString()}
                            </div>
                        </div>
                        <br/>
                        <div className="calendar-description">
                            <div className="calendar-event-text">
                                <Markdown>{item.description.replaceAll('\n', '  \n')}</Markdown>
                            </div>
                        </div>
                        <br/>
                        <br/>
                    </div>
                ))}
            </div>
            <div className={"col-sm-3 event-calendar-spacer"} style={{display: 'inline-block'}}></div>
        </div>
    );
}

export default EventCalendar;
